// copied from packages/ui/src/components/FlavorFinder/components/ResultsCardSpec/index.ts
export * from "./FlavorFinderResultsCardSpec";
